import { Component, Input } from '@angular/core';
import { AggregatedJobData, Job } from '@shared';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { Elevations } from 'mojo-card';

@Component({
  selector: 'mojo-dashboard-job-item',
  templateUrl: './dashboard-job-item.component.html',
})
export class DashboardJobItemComponent {
  @Input() jobItem: Job;
  @Input() avgResponseTime: string;
  @Input() aggregatedJobData: AggregatedJobData;

  avatarPhotoShape = AvatarShapes.circle;
  avatarBackgroundSizes = AvatarBackgroundSizes.cover;
  elevation = Elevations.first;
}
